export enum SortingAttribute {
  Name = 'Name',
  CompanyName = 'CompanyName',
  CreatedAt = 'CreatedAt',
  Owner = 'Owner',
  LatestActivityCreatedAt = 'LatestActivityCreatedAt',
}
